export default __webpack_public_path__ + "static/media/icn-trash.b624848b.svg";